<template>
  <OrderShow :id="id" currentPath="/admin/maestro/orders"/>
</template>

<script>
import OrderShow from '@/components/admin/order_flow/Show.vue'

export default {
  components: {OrderShow},
  name: 'AdminOrdersShow',
  props: {
    id: {required: true}
  }
}
</script>

<style scoped>
</style>
